import React, { useState } from "react";
import Grid from "@mui/material/Unstable_Grid2";
import { Box, Button, Link, Modal } from "@mui/material";
import BulkUploadForm from "../../Common/BulkUploadFormSP/BulkUploadForm";
import "../Attachment/Attachment.scss";

interface Props {
  open_status: boolean;
  attrName: any;
  value_update: Function;
}

const Attachment: React.FC<Props> = ({
  open_status,
  attrName,
  value_update,
}) => {
  const [deleteStatus, setDeleteStatus] = React.useState(false);
  const [uploadFile, setUploadFile] = React.useState(false);

  const updateMasterState = (attrName: any, value: any) => {
    attrName(value);
  };
  const attatchment_table_data = [
    {
      file_name: "621c94f41153e1835257b41b_lead mockup.webp",
      description: "Automation Enhancements and ...",
      Date: "30 Jan, 2023",
      time: "11 :30 A.M.",
    },
    {
      file_name: "621c94f41153e1835257b41b_lead mockup.webp",
      description: "Automation Enhancements and ...",
      Date: "25 Nov, 2022",
      time: "11 :30 A.M.",
    },
  ];

  return (
    <Box>
      <BulkUploadForm
        open_status={uploadFile}
        attrName={setUploadFile}
        value_update={updateMasterState}
      />
      <Grid container spacing={3}>
        <Grid xs={12}>
          <div className="table">
            <div className="attatchment_table" style={{ overflow: "hidden" }}>
              <ul className="heading">
                <li>File Name</li>
                <li>Description</li>
                <li>Date</li>
                <li>Time</li>
                <li>Actions</li>
              </ul>

              {attatchment_table_data.map((data, index) => (
                <ul className="subheading">
                  <li>{data.file_name}</li>
                  <li>{data.description}</li>
                  <li>
                    <p className="date">{data.Date}</p>
                  </li>
                  <li>
                    <p className="time">{data.time}</p>
                  </li>
                  <li
                    style={{
                      display: "flex",
                      justifyContent: "flex-start",
                    }}
                  >
                    <Link
                      className="blueBtn download ml-0"
                      sx={{
                        textDecoration: "none",
                        cursor: "pointer",
                      }}
                    ></Link>
                    <Link
                      className="redBtn delete"
                      onClick={() => {
                        setDeleteStatus(true);
                      }}
                      sx={{
                        textDecoration: "none",
                        cursor: "pointer",
                      }}
                    ></Link>
                  </li>
                </ul>
              ))}
            </div>
          </div>
        </Grid>
      </Grid>
      <Modal open={deleteStatus} className="modalWrapper">
        <Box className="modalInner">
          <Grid container spacing={1}>
            <Grid xs={12}>
              <Link
                className="close-button"
                onClick={() => {
                  setDeleteStatus(false);
                }}
              />
              <h5 className="popup-heading">Are you sure ?</h5>
            </Grid>
            <Grid xs={12}>
              <Link className="md-link" underline="none">
                You are about to Delete this Attatchment.
              </Link>
            </Grid>
            <Grid xs={12} className="ctaBtn" textAlign={"center"}>
              <Button variant="contained" className="submitBtn">
                Yes, Delete
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Modal>
    </Box>
  );
};

export default Attachment;
